export enum NestedRouteLevels {
    FIVE = 5,
    SIX = 6,
    SEVEN = 7,
}
